import React, { useState } from 'react';
import { Alert, Box, Button, Stack, Tab, Tabs, Typography } from '@mui/material';
import SelfServiceBranches from './SelfServiceBranches';
import SelfServiceCameras from './SelfServiceCameras';
import CameraAIConfig from '../saas/CameraAIConfig';
import Billing from './billing';

const sections = [
  { label: 'Sucursales', component: SelfServiceBranches },
  { label: 'Camaras', component: SelfServiceCameras },
  { label: 'Detecciones', component: CameraAIConfig },
  { label: 'Contratacion', component: Billing },
];

export default function SelfServicePortal({ onRefresh, onLogout }) {
  const [tab, setTab] = useState(0);
  const Current = sections[tab].component;
  return <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', p: { xs: 2, md: 4 } }}>
    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" gap={2} mb={2}>
      <Box><Typography variant="h4">Configura tu servicio</Typography>
        <Typography color="text.secondary">Selecciona camaras y detecciones, revisa la propuesta y completa el pago.</Typography></Box>
      <Stack direction="row" spacing={1}><Button variant="outlined" onClick={onRefresh}>Verificar acceso</Button><Button onClick={onLogout}>Salir</Button></Stack>
    </Stack>
    <Alert severity="info" sx={{ mb: 2 }}>El acceso al panel se habilita al confirmar el pago y su cobertura. El retorno de Mercado Pago no confirma por si solo la operacion.</Alert>
    <Alert severity="warning" sx={{ mb: 2 }}>El aprovisionamiento de Edge y la conexión real de cámaras requieren validación operativa. Registrarlas aquí no confirma que estén transmitiendo.</Alert>
    <Tabs value={tab} onChange={(_, next) => setTab(next)} variant="scrollable" scrollButtons="auto" aria-label="Configuracion inicial">
      {sections.map((item) => <Tab key={item.label} label={item.label} />)}
    </Tabs>
    <Box sx={{ mt: 2 }}><Current commercialSetup /></Box>
  </Box>;
}
